import { HeadContent } from '@fourthwall/components';
import React from 'react';
import { PageLayout } from '@components/common/PageLayout';
import { Analytics } from './modules/Analytics/Analytics';
import { Articles } from './modules/Articles';
import { Events } from './modules/Events/Events';
import { Header } from './modules/Header';
import { Onboarding } from './modules/Onboarding/Onboarding';
import { Suggestions } from './modules/Suggestions';
import { Video } from './modules/Video';
import { OverviewProvider } from './providers/OverviewProvider';
import * as S from './styled';
export const Overview = () => (React.createElement(OverviewProvider, null,
    React.createElement(HeadContent, { title: "Memberships overview" }),
    React.createElement(PageLayout, null,
        React.createElement(Header, null),
        React.createElement(S.Container, null,
            React.createElement(Video, null),
            React.createElement(Onboarding, null),
            React.createElement(Analytics, null),
            React.createElement(Events, null),
            React.createElement(Suggestions, null),
            React.createElement(Articles, null)))));
